<template>
  <van-notice-bar :class="$style.noticeSection" :scrollable="false">
    <van-swipe
      vertical
      :class="$style.noticeText"
      :autoplay="3000"
      :touchable="false"
      :show-indicators="false"
    >
      <van-swipe-item v-for="item in noticeList" :key="item"
        >温馨提示：{{ item }}</van-swipe-item
      >
    </van-swipe>
  </van-notice-bar>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'NoticeSection',

    data() {
      return {
        noticeList: [
          '同一品类限购2件，收货地址仅限贵州省内',
          '下单前请开启“多彩宝”APP实时定位授权',
          '申领 / 下单 / 收货务必使用同一手机号',
          '云闪付支付实名信息需与多彩宝实名一致',
        ],
      }
    },
  })
</script>

<style lang="scss" module>
  .noticeSection {
    background-color: #fff6ec;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .noticeText {
    font-size: 14px;
    color: #ff840a;
    height: 30px;
    line-height: 30px;
  }
</style>
